import { useLazyQuery, useQuery } from '@apollo/client'
import { Flex, Text, Card, Image } from 'rebass/styled-components'
import PleaseWait from '../../components/PleaseWait'
import { GET_INSURANCE_ON_FILE_FOR_PATIENT } from '../../graphql/queries'
import { IGetInsurancesOnFileInput, IGetInsurancesOnFileOutput } from '../../graphql/types/queries/patient'
import { getInsuranceLogoSource } from '../../utils/getInsuranceLogoSource'
import { useIsVisible } from '../../hooks/useIsVisible'
import { useRef, useEffect } from 'react'

interface IInsurancesProps {
  id: string
}

export const Insurances: React.FC<IInsurancesProps> = ({ id }) => {

  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IGetInsurancesOnFileOutput, IGetInsurancesOnFileInput>(GET_INSURANCE_ON_FILE_FOR_PATIENT, {
    variables: {
      patientId: parseInt(id, 10)
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])
  
  return (
    <Flex ref={ref} flexDirection={'column'} style={{ width: '100%', flex: 'initial',  paddingLeft: '20px', borderLeft: '3px solid #B8D6F5' }} paddingY={'12px'} mb={4}>
      <Text fontWeight={600} fontSize='18px' mb={3}>Insurances</Text>

      {!!loading ? (
        <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
          <PleaseWait
            text="Loading Patient's Insurances" />
        </Flex>
      ) : (
        <Flex flexDirection={'column'}>
          {data?.getInsurancesOnFileForPatient.map(x => {
            if (!x) return null
            return (
              <Flex mb={3} flexDirection='column'
              >
                <Text style={{ fontWeight: 500, fontSize: 16 }}>{x.sequenceNumber === 1 ? 'Primary Insurance:' : 'Secondary Insurance'}</Text>

                <Flex flexDirection={'column'}>
                  {x.insuranceCompany && getInsuranceLogoSource(x.insuranceCompany) && (
                    <Image style={{
                      maxHeight: 40,
                      maxWidth: '100%', objectFit: 'contain',
                      alignSelf: "flex-start"
                    }} height={40} src={getInsuranceLogoSource(x.insuranceCompany)} />
                  )}
                  <Text style={{ fontFamily: 'Poppins Medium', fontSize: 18, marginTop: 16 }}>{x.insuranceCompany}</Text>
                  <Text style={{ fontFamily: 'Poppins', fontSize: 16, marginBottom: 24 }}>{`Member ID: ${x.insuranceIdNumber}`}</Text>

                </Flex>
              </Flex>
            )
          })}
        </Flex>
      )
      }
    </Flex>);
}